import styled from 'styled-components';
export default styled.h1.withConfig({
  displayName: "Title",
  componentId: "sc-1xanbv8-0"
})(["font-size:3em;text-transform:", ";@media screen and (max-width:800px){font-size:2em;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.uppercaseTitles ? 'uppercase' : 'none';
});